import { Link } from "react-router-dom";
import { money } from "../lib/api";
import { useCart } from "../context/CartContext";
import { TiltMedia } from "./TiltMedia";
import { Layers } from "lucide-react";

// Bundle product card. Shows the sum of parts struck through, the stack price,
// and a save pill. Mirrors the competitor bundle grid, reskinned for Century Labs.
export const BundleCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const sum = product.compare_at_price || product.price;
  const save = Math.max(0, +(sum - product.price).toFixed(2));

  return (
    <div
      className="group border border-white/12 bg-[#0B1024] flex flex-col fade-up sq-lg overflow-hidden hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(110,96,255,0.15)] transition-all duration-300"
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`bundle-card-${product.slug}`}
    >
      <Link to={`/products/${product.slug}`} className="relative block overflow-hidden border-b border-white/12">
        <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1 bg-[#070B1C]/80 backdrop-blur-sm border border-white/15 text-white text-[9px] tracking-[0.18em] uppercase font-bold px-2.5 py-1 sq-xs">
          <Layers size={11} className="text-electric" /> Protocol
        </span>
        <TiltMedia className="aspect-square bg-[#0E1430]">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        </TiltMedia>
      </Link>

      <div className="p-4 sm:p-5 flex flex-col flex-1">
        <Link to={`/products/${product.slug}`}>
          <h3 className="font-display font-bold text-base uppercase tracking-tight leading-tight text-white hover:text-electric transition-colors duration-200">
            {product.name}
          </h3>
        </Link>
        {product.components?.length > 0 && (
          <p className="text-[11px] text-white/45 mt-1.5 leading-relaxed flex-1" data-testid={`bundle-contents-${product.slug}`}>
            {product.components.map((c) => c.name).join(" · ")}
          </p>
        )}
        <div className="flex items-baseline gap-2 mt-4">
          <span className="font-display font-bold text-xl text-white" data-testid={`bundle-price-${product.slug}`}>{money(product.price)}</span>
          {save > 0 && <span className="text-sm text-white/30 line-through">{money(sum)}</span>}
        </div>
        <button
          onClick={() => addItem(product, { tierQty: 1, packPrice: product.price })}
          className="btn-primary mt-4 w-full py-3 text-xs tracking-[0.2em] uppercase font-bold"
          data-testid={`bundle-add-${product.slug}`}
        >
          Add Protocol to Cart
        </button>
      </div>
    </div>
  );
};
